import {connect} from 'formik'
import {HolderTitle} from './'

export const HolderHeadline = connect(({formik}) => {
  const companyDonation = formik.values._company_donation
  const headline = companyDonation ? <h4>{I18n.t('donate.donor_headline.company')}</h4> : <HolderTitle/>
  const switchLabel = companyDonation ? I18n.t('donate.donor_headline.switch_to_personal') : I18n.t('donate.donor_headline.switch_to_company')

  return <div className='flex justify-between items-baseline'>
    <div className="donations-form-holder-label">
      {headline}
    </div>
    <span className='donation-form-company-toggle simulated-link font-weight-400 small' onClick={() => {
      formik.setFieldValue('_company_donation', !companyDonation)
      if (!formik.values.receipt_desired) formik.setFieldValue('receipt_desired', true)
    }}>
      {switchLabel}
    </span>
  </div>
})
